import Debug from "debug";

const debug = Debug("cs.PrismicToolbar");

function insertPrismicScript() {
  const slot = document.getElementsByTagName("head")[0];

  const script = document.createElement("script");
  script.src = "//static.cdn.prismic.io/prismic.js?repo=characterscope&new=true";
  script.type = "text/javascript";

  slot.appendChild(script);
}

// This changes the behaviour of the prismic end session button to do what we want it to do.
function fixPrismicToolbarCloseButton() {
  let success = false;
  const prismicRoot = document.querySelector("#prismic-toolbar-v2");
  const closeButton = prismicRoot?.shadowRoot?.querySelector(".Icon.x");

  if (closeButton) {
    (closeButton as HTMLElement).onmousedown = (e) => {
      let url = window.location.href;
      url = url.replace(/&previewMode=true/g, "");
      url = url.replace(/\?previewMode=true/g, "");

      window.location.href = url;
    };

    success = true;
  }

  if (!success) {
    window.setTimeout(fixPrismicToolbarCloseButton, 100);
  }
}

const now = new Date().getTime();
const navStart = performance?.timing?.navigationStart;
const timeToLoad = now - navStart;

let enabled = false;

export default function enablePrismicToolbar(): void {
  if (!enabled) {
    enabled = true;
    // This is to prevent prismic buggy refresh loops causing problems.
    if (timeToLoad && timeToLoad < 8000) {
      // eslint-disable-next-line no-console
      debug("Enabling prismic toolbar.");
      insertPrismicScript();
      fixPrismicToolbarCloseButton();
    } else {
      debug(`Not loading prismic toolbar; Navigation time was too long, ${timeToLoad}ms.`);
    }
  }
}
